'use client'

import { FooterV3 } from '@/components/home-v3/footer'
import { HeaderV3 } from '@/components/home-v3/header'
import { ProjectsV3 } from '@/components/home-v3/projects'
import { Comparison } from '@/components/home-v3/sections/comparison'
import { FAQ } from '@/components/home-v3/sections/faq'
import { Hero } from '@/components/home-v3/sections/hero-section'
import { StructuredData } from '@/components/home-v3/structured-data'
import { PageTracker } from '@/components/page-tracker'
import type { User } from '@/lib/types'

/**
 * Client-side wrapper for homepage to improve TTFB
 * Fetches user data on client instead of server
 */
export function HomePageClientWrapper({ user }: { user: User | null }) {
  return (
    <>
      <StructuredData />
      <PageTracker pageName="homepage-v3" eventName="HOMEPAGE_PAGE_VIEW" />

      <div className="min-h-screen text-white border-0 relative overflow-x-hidden bg-black">
        <HeaderV3 user={user ?? null} />
        <Hero user={user as User} />
        <ProjectsV3 user={user ?? null} />
        <Comparison />
        <FAQ />
        <FooterV3 />
      </div>
    </>
  )
}
